import React from 'react';
import StateTaxForm from '../components/StateTaxForm';

const Goa = () => {
  return <StateTaxForm stateKey='goa' />;
};

export default Goa;
